/**
 * Keep track of loaded scripts, used to only load once
 */
const loadedScripts = [];

export function injectScript(src, async) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = async;
    script.src = src;
    const domNode = document.getElementsByTagName('script')[0];
    domNode.parentNode.insertBefore(script, domNode);
}

export function loadScript(src, options) {
    // eslint-disable-next-line no-param-reassign
    options = {
        ...{
            async: true,
            forceLoad: false,
        },
        ...options,
    };
    if (options.forceLoad || !loadedScripts.includes(src)) {
        injectScript(src, options.async);
        loadedScripts.push(src);
    }
}

